import { Component, OnInit } from '@angular/core';

import { SmartSmsService } from 'src/app/core/api/services';
import { BaseSelectionList } from '../base/base-selection-list.component';

@Component({
    selector: 'device-type-selection-list',
    templateUrl: './device-type-selection-list.component.html',
    standalone: false
})
export class DeviceTypeSelectionListComponent
  extends BaseSelectionList
  implements OnInit
{
  constructor(protected currentService: SmartSmsService) {
    super();
  }

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'name';

    if (!this.input_label) this.input_label = 'common.deviceTypes';
  }

  getItems() {
    if (this.loading) return;
    this.loading = true;

    this.currentService
      .smartSmsGetDeviceTypes()
      .pipe(this.baseSelectionSearchPipeOperators)
      .subscribe((items) => {
        this.items = items?.data;
      });
  }
}
